import React from "react";
import { motion } from "framer-motion";
import { Trophy, Lightning, Timer } from "@phosphor-icons/react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1628935291759-bbaf33a66dc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGd5bXxlbnwwfHx8fDE3NzU3NTMxMDl8MA&ixlib=rb-4.1.0&q=85"
                alt="Influencer working out"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-60" />
            </div>
            {/* Floating badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, duration: 0.5 }}
              className="absolute -bottom-4 -right-4 md:bottom-8 md:-right-8 bg-[#FF3B30] px-6 py-4"
            >
              <p className="font-['Barlow_Condensed'] text-3xl font-black text-white">5+</p>
              <p className="text-xs uppercase tracking-wider text-white/80 font-bold">Years Active</p>
            </motion.div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7"
          >
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#FF3B30] mb-4">
              The Story
            </p>
            <h2
              data-testid="about-heading"
              className="font-['Barlow_Condensed'] text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white mb-8"
            >
              More Than Just
              <br />
              An Influencer
            </h2>
            <p className="text-base sm:text-lg text-white/50 leading-relaxed mb-8 max-w-xl">
              With over five years in the fitness and wellness space, I've built a community
              of dedicated followers who trust my recommendations. My content philosophy
              centers on authenticity — every partnership is carefully curated to align with
              my audience's values and wellness goals.
            </p>
            <p className="text-base sm:text-lg text-white/50 leading-relaxed mb-12 max-w-xl">
              From supplement brands to luxury activewear, I've driven measurable ROI
              through strategic content creation, storytelling, and genuine engagement
              that converts viewers into customers.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                { icon: Trophy, label: "50+ Brand Deals", desc: "Completed" },
                { icon: Lightning, label: "3x Avg. ROI", desc: "For Partners" },
                { icon: Timer, label: "48hr Turnaround", desc: "On Content" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex items-start gap-3"
                  data-testid={`about-stat-${item.label.toLowerCase().replace(/[\s+]/g, '-')}`}
                >
                  <div className="w-10 h-10 bg-[#FF3B30]/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <item.icon size={20} weight="bold" className="text-[#FF3B30]" />
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm">{item.label}</p>
                    <p className="text-white/40 text-xs uppercase tracking-wider">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
